<template>
<div class="chapter">
<div class="inner_page">
<div class="imagefpw"><a id="page_iv"><img alt="Vanished!, by James Ponti, Aladdin" class="imagefpw" src="images/title01.jpg"/></a><a id="page_v"></a></div><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4677ecdb